/** @jsxImportSource @emotion/react */
import { TableRow } from "../../components/table-components/TableRow";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { Avatar } from "../../components/Avatar";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { formatMoneyAmount } from "../../util";
import { firstTableCellStyle } from "../../style-util";
import { localStorageScrollPositionName } from "./ProductsList";
import { css } from "@emotion/react";
import { ProductDropdown } from "./ProductDropdown";
import { ProductListItem } from "./models/product";

type Props = {
  product: ProductListItem;
};

const ellipsisWrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: fit-content;
`;

const dropdownWrapperStyle = css`
  display: flex;
  align-items: end;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`;

export const ProductsTableRow = ({ product }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const href = routes.productEdit(organizationKeyName, product.id);

  return (
    <TableRow
      onClick={() => {
        if (localStorage) {
          localStorage.setItem(
            localStorageScrollPositionName,
            JSON.stringify(window.scrollY)
          );
        }
      }}
    >
      <TableCellLink css={firstTableCellStyle} href={href}>
        <Avatar size="small" imageUrl={product.imageUrl} rounded={true}>
          {product.name.charAt(0).toUpperCase()}
        </Avatar>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {product.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {product.title}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {product.categoryName || "-"}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {formatMoneyAmount(product.price?.amount!, product.price?.currency!)}
        </StyledText>
      </TableCellLink>
      <td css={dropdownWrapperStyle}>
        <div css={ellipsisWrapperStyle}>
          <ProductDropdown product={product} />
        </div>
      </td>
    </TableRow>
  );
};
